import { render } from "./caseta.vue?vue&type=template&id=3f0dae3b"
const script = {}

import "./caseta.vue?vue&type=style&index=0&id=3f0dae3b&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__